export function filterHiddenParamsFromConfig(xmlString: string): string {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    // Check for parser errors
    const parserError = xmlDoc.querySelector("parsererror");
    if (parserError) {
      console.error("Error parsing XML:", parserError.textContent);
      // Return original string or throw error, returning original for now
      return xmlString;
    }

    const steps = xmlDoc.querySelectorAll("step");

    steps.forEach((step) => {
      const params = step.querySelectorAll("param");
      params.forEach((param) => {
        if (param.getAttribute("hidden") === "true") {
          param.parentNode?.removeChild(param);
        }
      });
    });

    const serializer = new XMLSerializer();
    return serializer.serializeToString(xmlDoc);
  } catch (error) {
    console.error("Error filtering XML config:", error);
    // Return original string in case of unexpected errors during processing
    return xmlString;
  }
}
